// Services
import ApiService from "../services/api.service"

const model = 'notes'

export default class NotesService {
  static list(search = false, limit = 10, skip = 0, fields = '', filter = false) {
    if (search && search !== '') search = `{"description": "regex:${search}"}`
    return ApiService.list(model, { search, filter, limit, skip, fields }).then(response => response.data)
  }

  static get(interviewId) {
    return ApiService.get(`${model}/${interviewId}`).then(response => response.data)
  }
  
  static post(data = {}) {
    return ApiService.post(model, data).then(response => response)
  }
  
  static patch(noteId, patch = {}) {
    return ApiService.patch(`${model}/${noteId}`, patch).then(response => response) 
  }
  
  static delete(noteId) {
    return ApiService.delete(`${model}/${noteId}`).then(response => response) 
  } 
}